export default [
  {
    name: 'GuideStyle',
    path: '/guide/style',
    component() {
      return import('@/pages/guide/Style.vue')
    },
  },
]
